module.exports = __webpack_public_path__ + "node_modules/icheck/skins/flat/red.png?ed1ce193";